<template>
    <div class="mb-2">
        <h5 class="text-dark px-2 pt-2 pb-0 mb-0">{{ currentUser.full_name }}</h5>
        <span class="text-sm text-black-50 px-2">{{ currentUser.email }}</span>
    </div>
    <nav>
        <ul class="list-unstyled">
            <!-- <li class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">map_search</i>
                <router-link to="/search">
                    <span>Réserver</span>
                </router-link>
            </li> -->
            <li class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">event</i>
                <a href="/my/bookings"><span>Réservations</span></a>
            </li>
            <li class="d-flex align-items-center p-2">
                <!-- <i class="material-symbols-outlined text-lg mr-2">apparel</i> -->
                <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#505050" class="mr-2">
                    <path
                        d="m240-522-40 22q-14 8-30 4t-24-18L66-654q-8-14-4-30t18-24l230-132h70q9 0 14.5 5.5T400-820v20q0 33 23.5 56.5T480-720q33 0 56.5-23.5T560-800v-20q0-9 5.5-14.5T580-840h70l230 132q14 8 18 24t-4 30l-80 140q-8 14-23.5 17.5T760-501l-40-20v361q0 17-11.5 28.5T680-120H280q-17 0-28.5-11.5T240-160v-362Zm80-134v456h320v-456l124 68 42-70-172-100q-15 51-56.5 84.5T480-640q-56 0-97.5-33.5T326-758L154-658l42 70 124-68Zm160 177Z" />
                </svg>
                <a href="/my/player-profile"><span>Profil Joueur</span></a>
            </li>
            <li class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">groups</i>
                <a href="/my/teams"><span>Équipes</span></a>
            </li>
            <!-- <li class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">sports_soccer</i>
                <a href="/my/matches"><span>Matchs</span></a>
            </li> -->
            <li class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">scoreboard</i>
                <a href="/my/challenges"><span>Défis publics</span></a>
            </li>
            <li class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">format_list_numbered</i>
                <a href="/my/standing"><span>Classement</span></a>
            </li>
            <li class="d-flex align-items-center p-2">
                <span class="position-relative">
                    <i class="material-symbols-outlined text-lg mr-2">notifications</i>
                    <span v-if="unread_notifications.length > 0"
                        class="position-absolute rounded-circle bg-danger border-white" style="top: 0; right: .5rem; width: 6px; height: 6px;"></span>
                </span>
                <a href="/my/notifications"><span>Notifications</span></a>
            </li>
            <li class="d-flex align-items-center p-2">
                <i class="fab fa-whatsapp text-success mr-1 px-1 text-md"></i>
                <a href="https://chat.whatsapp.com/Jpue7wD6FYB8gNJBKrIj6q" target="_blank">
                    <span>Rejoindre Communauté</span>
                </a>
            </li>
            <hr class="my-2 mx-2"/>
            <li class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">manage_accounts</i>
                <a href="/my/profile"><span>Profil</span></a>
            </li>
            <li class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">password</i>
                <a href="/my/change-password"><span>Changer Mot de Passe</span></a>
            </li>
            <li class="d-flex align-items-center p-2">
                <i class="material-symbols-outlined text-lg mr-2">logout</i>
                <a href="#" @click.prevent="logout">
                    <span>Se Déconnecter</span>
                </a>
            </li>
        </ul>
    </nav>
</template>
<style scoped>
.dashboard-menu>ul>li>a.active {
    color: #e5bd54;
}
</style>
<script>
export default {
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        notifications() {
            const notifications = this.$store.getters.notifications;
            return notifications && Array.isArray(notifications) ? notifications : []
        },
        unread_notifications() {
            const notifications = this.$store.getters.notifications;
            return notifications && Array.isArray(notifications) ? notifications.filter(notification => !notification['is_read']) : []
        },
    },
    data() {
        return {
            isMobile: false
        }
    },
    mounted() {
        this.setupMediaQuery();
        // Initial check when the component mounts
        this.isMobile = this.mediaQuery.matches;
        // Add event listener for changes
        this.mediaQuery.addEventListener('change', this.handleMediaQueryChange);
    },
    beforeUnmount() {
        // Clean up the event listener to prevent memory leaks
        if (this.mediaQuery) {
            this.mediaQuery.removeEventListener('change', this.handleMediaQueryChange);
        }
    },
    methods: {
        setupMediaQuery() {
            // The Tailwind md breakpoint is 768px
            this.mediaQuery = window.matchMedia('(max-width: 768px)');
        },
        handleMediaQueryChange(event) {
            // Update the isMobile data property when the screen size changes
            this.isMobile = event.matches;
        },
        logout() {
            this.$store.dispatch("logout");
        },
    },
};
</script>
